import React from 'react';
import PropTypes from 'prop-types';
import { default as MUiTooltip } from '@material-ui/core/Tooltip';

import { Text } from '../index';

import { useStylesTooltip } from './style';

export const Tooltip = ({ title, children, ...rest }) => {
    const classes = useStylesTooltip();

    return (
        <MUiTooltip
            classes={{
                tooltip: classes.customTooltip,
                arrow: classes.customArrow,
            }}
            title={
                <div style={{ padding: '5px 12px' }}>
                    <Text $fontSize="16px" $color="gray4">
                        {title}
                    </Text>
                </div>
            }
            arrow
            placement="top"
            {...rest}
        >
            {children}
        </MUiTooltip>
    );
};

Tooltip.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    rest: PropTypes.object,
};
